import { safeIntercom } from './safe'

/**
 * Open the support messenger.
 *
 * Deliberately no prefilled text. Putting words in the user's mouth ("Hi!
 * I'm stuck and could use a hand with…") reads oddly on arrival and has to
 * be deleted before they can say their own thing — the messenger opening at
 * all is the affordance that matters.
 *
 * `show` rather than `showNewMessage`: it opens the messenger proper, so
 * anyone with a conversation already running lands back in it instead of
 * starting a second one.
 *
 * Shared so the Help menu and the blank-slate prompt behave identically.
 * No-ops where Intercom is absent (the MS Teams build) — every caller must
 * still gate its UI on `isIntercomAvailable()` and offer the mailto instead,
 * or the click does nothing at all.
 */
export const openSupportChat = (): void => {
  safeIntercom('show')
}

export default openSupportChat
